import {CONSTANTS} from '@/constants';
import miniToastr from 'mini-toastr'

export const functions_customers = {

    data: function () {
        return {
            customer:null,
            customers:null,
            customers_loaded: false
        };
    },

    computed: {
        is_customer_loaded: function () {
            return this.isCustomerLoaded();
        },
        is_customers_loaded: function () {
            return this.isCustomersLoaded();
        },
    },

    methods: {
        customerFullname: function(customer) {
            let name = '';
            if (customer) {
                if (is(customer.surname)) {
                    name += customer.surname;
                }
                if (is(customer.name)) {
                    if (is(name)) {
                        name += ' ';
                    }
                    name += customer.name;
                }
                if (is(customer.patro)) {
                    if (is(customer.patro)) {
                        name += ' ';
                    }
                    name += customer.patro;
                }
            }
            return name;
        },
        customerTitle: function (customer) {
            if (customer) {
                if (customer.is_org && is(customer.org_name)) {
                    return customer.org_name;
                }

                if (is(customer.name) || is(customer.surname)) {
                    return this.customerFullname(customer);
                }
            }

            return 'Безымянный заказчик';
        },

        customerSubtitle: function (customer) {
            if (customer) {
                if (customer.is_org && is(customer.org_name)) {
                    return this.customerFullname(customer);
                }
            }
            return '';
        },

        /*
         *  Заказчик
         */

        loadCustomer: function (customer_id, onSuccess=null, param=null) {
            if (!this.isCustomerLoaded() && customer_id) {
                this.customer = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('customer/' + customer_id )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.customer = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        isCustomerLoaded: function () {
            return (this.customer !== null) && this.customer;
        },

        resetCustomer: function () {
            this.customer = null;
            return this;
        },

        saveCustomer: function (extra, onSuccess=null, param=null) {
            this.customer.extra_password = extra.password;
            this.httpPrepare();
            this.$http.put(this.apiurl('customer/'+this.customer.id+'/save'), this.customer).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param);
                miniToastr["success"]('Заказчик #'+this.customer.id+' сохранен', null, 5000);
            }, this.httpError)
        },

        loadCustomers: function (onSuccess=null, param=null) {
            if (!this.isCustomersLoaded()) {
                this.customers_loaded = false;
                this.httpPrepare();
                this.$http.get(this.apiurl('city/a')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.customers = response.payload;
                    this.customers_loaded = true;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        lookupCustomer: function (customer_info, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('customer/lookup'), customer_info).then(function (response) {
                response = this.httpSuccess(response);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError)
        },

        isCustomersLoaded: function () {
            return (this.customers !== null) && this.customers.length && this.customers_loaded;
        },

        resetCustomers: function () {
            this.customers = [];
            return this;
        },

        canEditCustomer: function (customer) {
            if (!customer) {
                return false;
            }

            if (this.is_agent) {
                if (customer.user_id === this.my_id) {
                    return true;
                }
            }
            if (this.is_agency) {
                if (customer.company_id === this.my_company_id) {
                    return true;
                }
            }
            if (this.is_admin || this.is_god) {
                return true;
            }

            return false;
        },

        canShowCustomer: function (customer) {
            if (!customer) {
                return false;
            }

            if (this.is_agent) {
                if (customer.user_id === this.my_id) {
                    return true;
                }
            }
            if (this.is_agent_or_agency) {
                if (customer.company_id === this.my_company_id) {
                    return true;
                }
            }
            if (this.is_admin || this.is_god) {
                return true;
            }

            return false;
        },

        customerDescription: function (customer) {
            let d = "#"+customer.id;
            if (customer.tel) d += ", тел:"+customer.tel;
            if (customer.email) d += ", e-mail:"+customer.email;
            if (customer.is_org) {
                d += ", организация:"+customer.org_name;

                if (customer.org_inn) {
                    d += ", ИНН:"+customer.org_inn;
                }
                if (customer.org_kpp) {
                    d += ", КПП:"+customer.org_kpp;
                }
            }
            return d;
        },

        createCustomer: function (customer_info, onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.put(this.apiurl('customer/create'), customer_info).then(function (response) {
                response = this.httpSuccess(response);
                console.log('createCustomer', response);
                this.executeFunction(onSuccess, param, response.payload);
                miniToastr["success"]('Заказчик #'+response.payload+' создан', null, 15000);
            }, this.httpError)
        },
    },

}
